import { LoanReferenceCreate } from './LoanReferenceCreate';

const LoanReferences: object = {
  create: LoanReferenceCreate,
};

export default LoanReferences;
